import { jwtDecode } from "jwt-decode";
import { JwtPayloadInterface } from "../interfaces";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../constants";

export const useAuthenticatedUserRole = (): string => {
  const token = window.localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT);

  if (!token) {
    console.error("No token found");
    return null;
  }

  try {
    const decodedToken = jwtDecode<JwtPayloadInterface>(token);
    return decodedToken.role;
  } catch (error) {
    console.error("Failed to decode token", error);
    return null;
  }
};
